import { render } from "./ClustersSidebarContent.vue?vue&type=template&id=06c72b4a&ts=true"
import script from "./ClustersSidebarContent.vue?vue&type=script&lang=ts"
export * from "./ClustersSidebarContent.vue?vue&type=script&lang=ts"

import "./ClustersSidebarContent.vue?vue&type=style&index=0&id=06c72b4a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__